import api from "@/lib/api";

const KEY = "rsp_vid";

export function getVisitorId() {
  try {
    let v = localStorage.getItem(KEY);
    if (!v) {
      v = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`).replace(/-/g, "");
      localStorage.setItem(KEY, v);
    }
    return v;
  } catch (e) { return null; }
}

let sent = false;
export async function trackVisit() {
  if (sent) return;
  sent = true;
  const visitor_id = getVisitorId();
  if (!visitor_id) return;
  try {
    await api.post("/track/visit", { visitor_id, url: window.location.href, referrer: document.referrer || "", path: window.location.pathname });
  } catch (e) {}
}
